.header {
  padding: 20px;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 20px;
}

.container {
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.link {
  font-size: 16px;
  font-weight: 500;
  color: #0a66c2;
  text-decoration: none;
  transition: color 0.2s ease;
}

.link:hover {
  color: #004182;
  text-decoration: underline;
}

.form {
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;
}

.input {
  padding: 10px 12px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 240px;
}

.button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #0a66c2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.button:hover {
  background-color: #004182;
}
